
import Stepper from './parts/Stepper.vue'
import MetaStrip from './parts/MetaStrip.vue'
import FooterNav from './parts/FooterNav.vue'
import { wizardForRoute } from '~/data/wizards'

export default {
    components: { Stepper, MetaStrip, FooterNav },
    props: {
        stepId: { type: String, required: true },
        stepError: { type: String, default: null },
        nextLabel: { type: String, default: 'Continue' },
        hideBack: { type: Boolean, default: false },
        hideNext: { type: Boolean, default: false },
        hideChrome: { type: Boolean, default: false },
        // True while the step's data isn't hydrated yet (cold start — see
        // checkup-page.js's `surveyReady`). Every page wires this as
        // `:loading='!surveyReady'`.
        loading: { type: Boolean, default: false },
    },
    computed: {
        // Which wizard this shell is driving, resolved from the route rather
        // than passed down, so the ten existing /checkup/* pages need no
        // change to keep working (#656). data/wizards.js falls back to the
        // checkup wizard when the route doesn't match one.
        wizard () { return wizardForRoute(this.$route) },
        // The numbered run only — a wizard may bookend itself with steps that
        // sit outside the chrome (/renewal's landing and confirmation). For
        // checkup this is still all 9 steps, so the stepper, progress bar and
        // meta strip render exactly as before.
        steps () { return this.wizard.visibleStepsFor(this.$store.getters) },
        stepIdx () { return this.steps.findIndex(s => s.id === this.stepId) },
        progressPct () { return `${(this.stepIdx / (this.steps.length - 1)) * 100}%` },
        // Where "save and finish later" returns to: the wizard's own first
        // step, not a hardcoded /checkup/welcome.
        homePath () { return this.wizard.steps[0].path },
    },
    methods: {
        onGo (id) {
            // Resolve against the wizard's FULL step list, not `steps` — a
            // chrome-less step is still a legitimate jump target.
            const step = this.wizard.steps[this.wizard.stepIndex(id)]
            if (!step) { return }
            this.$router.push({ path: step.path, query: this.$route.query })
        },
        onSaveLater () {
            // Everything autosaves; this is a reassurance affordance.
            this.$success('Your progress is saved. You can come back any time.')
            if (this.$route.path !== this.homePath) {
                this.$router.push({ path: this.homePath, query: this.$route.query })
            }
        },
    },
}
